import { CompanyList } from "./CompanyList";
import { CompanyShow } from "./CompanyShow";
import { CompanyEdit } from "./CompanyEdit";

export default {
  list: CompanyList,
  // create omitted — companies sync from BC (see misc/bcMasterData.ts)
  edit: CompanyEdit,
  show: CompanyShow,
};
